/* eslint-disable no-new-object */

import * as Constants from "utils/Constants";

import { CONFIGURATION, USERMANAGEMENT, PROCESSINGITEMS } from "redux/constants/action-types";

import HelperFunctions from "utils/HelperFunctions";
import axios from "axios";
import toast from "../../../utils/toast";

export function editEmailSettingParams(clientId, data, type) {
  return async function (dispatch) {
    try {
      await axios.post(
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
          "Configuration/EmailConfiguration/EditEmailConfigurationParams",
        data,
        {
          params: {
            clientId: clientId,
          },
        }
      );
      dispatch(getEmailSettingItems(clientId, type));
      dispatch(getEmailConfigFormItems(clientId));
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function addEmailSettingParams(clientId, data, type) {
  return async function (dispatch) {
    try {
      await axios.post(
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
          "Configuration/EmailConfiguration/AddEmailConfigListItems",
        data,
        {
          params: {
            clientId: clientId,
            configuratuionType: type,
          },
        }
      );
      dispatch(getEmailSettingItems(clientId, type));
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function addEmailConfigListItemsListBulk(clientId, data, type) {
  return async function (dispatch) {
    try {
      await axios.post(
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
          "Configuration/EmailConfiguration/AddEmailConfigListItemsListBulk",
        data,
        {
          params: {
            clientId: clientId,
            configuratuionType: type,
          },
        }
      );
      dispatch(getEmailConfigFormItems(clientId))
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function addCSVFileItems(clientId, file, type, configListId) {
  return async function (dispatch) {
    try {
      await axios.post(
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
          "Configuration/EmailConfiguration/AddCSVFileItems",
        file,
        {
          params: {
            clientId: clientId,
            configuratuionType: type,
            configurationListId: configListId,
          },
        }
      );
      dispatch(getEmailSettingItems(clientId, type));
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function addUpdateDesignViewMode(clientId, designViewMode, viewArea) {
  return async function (dispatch) {
    try {
      await axios.post((import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
          `Configuration/UserManagement/SaveUpdateDesignViewMode?clientId=${clientId}&designViewMode=${designViewMode}&viewArea=${viewArea}`,
        null,
        {
          suppressToast: true,
        }
      );
      
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function saveUpdateFolderViewMode(clientId, isFolderView, viewArea) {
  return async function (dispatch) {
    try {
      await axios.post(
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
          `Configuration/UserManagement/SaveUpdateFolderViewMode?clientId=${clientId}&isFolderView=${isFolderView}&viewArea=${viewArea}`,
        null,
        {
          suppressToast: true,
        }
      );
      
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function addConfigurationList(clientId, data, configurationType) {
  return async function (dispatch) {
    try {
      await axios.post(
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
          "Configuration/EmailConfiguration/AddConfigurationList",
        data,
        {
          params: {
            clientId: clientId,
            configuratuionType: configurationType,
          },
          suppressToast: true,
        }
      );

      dispatch(getConfigurationList(clientId, configurationType));
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function editConfigurationList(clientId, data, configurationType) {
  return async function (dispatch) {
    try {
      await axios.post(
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
          "Configuration/EmailConfiguration/EditConfigurationList",
        data,
        {
          params: {
            clientId: clientId,
            configuratuionType: configurationType,
          },
        }
      );

      dispatch(getConfigurationList(clientId, configurationType));
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function addUpdateESPCommenting(clientId, commentingStatus) {
  return async function (dispatch) {
    try {
      await axios.post(
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
          `Configuration/EmailConfiguration/AddUpdateESPCommenting?clientId=${clientId}&commentingStatus=${commentingStatus}`//,
      );

      dispatch(getEmailConfigFormItems(clientId));
      } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function addUpdateESPAmpSupport(clientId, beeAmpSupportStatus) {
  return async function (dispatch) {
    try {
      console.log('addUpdateESPAmpSupport: ', beeAmpSupportStatus);
      await axios.post(
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
          `Configuration/EmailConfiguration/AddUpdateESPAMPSupport?clientId=${clientId}&ampSupportStatus=${beeAmpSupportStatus}`
      );

      dispatch(getEmailConfigFormItems(clientId));
      } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getTrackingParametersByClientId(clientId) {
  return async function (dispatch) {
    try {

      let URL =
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
        "Configuration/EmailConfiguration/GetEmailConfigurationItems?clientId=" +
        clientId +
        "&configuratuionType=" +
        "TrackingParameter";
      const response = await axios.get(URL);
      console.log("getTrackingParametersByClientId => ", response)
      dispatch({
        type: CONFIGURATION.GET_TRACKINGPARAMETER_BY_CLIENTID,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
      
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getEmailSettingItems(clientId, configurationType) {
  return async function (dispatch) {
    try {
      let URL =
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
        "Configuration/EmailConfiguration/GetEmailConfigurationItems?clientId=" +
        clientId +
        "&configuratuionType=" +
        configurationType;
      const response = await axios.get(URL);
      const { CONFIGURATION_TYPES } = Constants;

      switch (configurationType) {
        case CONFIGURATION_TYPES.SeedList:
          dispatch({
            type: CONFIGURATION.GET_SEEDLIST_BY_CLIENTID,
            payload: HelperFunctions.responseHandlerVNext(response.data),
          });
          break;
        case CONFIGURATION_TYPES.TestList:
          dispatch({
            type: CONFIGURATION.GET_TESTLIST_BY_CLIENTID,
            payload: HelperFunctions.responseHandlerVNext(response.data),
          });
          break;
        case CONFIGURATION_TYPES.FromEmail:
          dispatch({
            type: CONFIGURATION.GET_FROMEMAIL_BY_CLIENTID,
            payload: HelperFunctions.responseHandlerVNext(response.data),
          });
          break;
        case CONFIGURATION_TYPES.ReplyToEmail:
          dispatch({
            type: CONFIGURATION.GET_TOEMAIL_BY_CLIENTID,
            payload: HelperFunctions.responseHandlerVNext(response.data),
          });
          break;
        case CONFIGURATION_TYPES.TrackingParameter:
          dispatch({
            type: CONFIGURATION.GET_TRACKINGPARAMETER_BY_CLIENTID,
            payload: HelperFunctions.responseHandlerVNext(response.data),
          });
          break;
        case CONFIGURATION_TYPES.FromName:
          dispatch({
            type: CONFIGURATION.GET_FROMNAME_BY_CLIENTID,
            payload: HelperFunctions.responseHandlerVNext(response.data),
          });
          break;
        case CONFIGURATION_TYPES.AppendTrackingParameters:
          dispatch({
            type: CONFIGURATION.GET_APPENDTRACKINGPARAMS_BY_CLIENTID,
            payload: HelperFunctions.responseHandlerVNext(response.data),
          });
          break;
        default:
          // Logging unknown case to identify if any case is not handled and needs to be handled
          console.log("No match case found for " + configurationType);
          break;
      }
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getEmailConfigFormItems(clientId) {
  return async function (dispatch) {
    try {
      let URL =
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
        "Configuration/EmailConfiguration/GetEmailConfigFormItems?clientId=" +
        clientId;
      const response = await axios.get(URL);
      dispatch({
        type: CONFIGURATION.GET_EMAILCONFIGFORM_BY_CLIENTID,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getConfigurationList(clientId, configurationType) {
  return async function (dispatch) {
    try {
      let URL =
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
        "Configuration/EmailConfiguration/GetConfigurationList?clientId=" +
        clientId +
        "&configuratuionType=" +
        configurationType;
      const response = await axios.get(URL);

      switch (configurationType) {
        case "SeedList":
          dispatch({
            type: CONFIGURATION.GET_SEEDLIST_FROM_CONFIGURATIONLIST,
            payload: HelperFunctions.responseHandlerVNext(response.data),
          });
          break;
        case "TestList":
          dispatch({
            type: CONFIGURATION.GET_TESTLIST_FROM_CONFIGURATIONLIST,
            payload: HelperFunctions.responseHandlerVNext(response.data),
          });
          break;
        default:
          // Logging unknown case to identify if any case is not handled and needs to be handled
          console.log("No match case found for " + configurationType);
          break;
      }
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getSMSConfigurationList(clientId, configurationType) {
  return async function (dispatch) {
    try {
      let URL =
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
        "Configuration/SMSConfiguration/GetConfigurationList?clientId=" +
        clientId +
        "&configuratuionType=" +
        configurationType;
      const response = await axios.get(URL);

      switch (configurationType) {
        case "SeedList":
          dispatch({
            type: CONFIGURATION.GET_SMS_SEEDLIST_FROM_CONFIGURATIONLIST,
            payload: HelperFunctions.responseHandlerVNext(response.data),
          });
          break;
        case "TestList":
          dispatch({
            type: CONFIGURATION.GET_SMS_TESTLIST_FROM_CONFIGURATIONLIST,
            payload: HelperFunctions.responseHandlerVNext(response.data),
          });
          break;
        default:
          // Logging unknown case to identify if any case is not handled and needs to be handled
          console.log("No match case found for " + configurationType);
          break;
      }
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getConfiguredIntegrationList(clientId) {
  return async function (dispatch) {
    try {
      let URL =
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
        "Configuration/Integration/GetAll";
      const response = await axios.get(URL);
      dispatch({
        type: CONFIGURATION.GET_CONFIGURATION_INTEGRATIONLIST_BY_CLIENTID,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getIntegrationListByProviderCategories(clientId) {
  return async function (dispatch) {
    try {
      let URL =
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
        "Configuration/Integration/GetProvidersByProviderCategories?clientId="+clientId;
      const response = await axios.get(URL);
      dispatch({
        type: CONFIGURATION.GET_CONFIGURATION_INTEGRATIONLIST_BY_PROVIDER_CATEGORIES,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getIntegrationProviderCategories(clientId) {
  return async function (dispatch) {
    try {
      let URL =
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
        "Configuration/Integration/GetAllProviderCategories";
      const response = await axios.get(URL);
      dispatch({
        type: CONFIGURATION.GET_CONFIGURATION_PROVIDER_CATEGORIES,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getRequiredParamsForintegration(clientId, providerId) {
  return async function (dispatch) {
    try {
      dispatch(setLoading(true));
      let URL =
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
        "Configuration/Integration/GetRequiredParamsForintegration?clientId=" +
        clientId +
        "&providerId=" +
        providerId; //+"&dataIntegrationSP="+dataIntegrationSP;
      const response = await axios.get(URL);
      dispatch({
        type: CONFIGURATION.GET_CONFIGURATION_INTEGRATIONPARAMS_BYPROVIDEID,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setLoading(false));
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function setLoading(value) {
  return async function (dispatch) {
    dispatch({
      type: CONFIGURATION.IS_LOADING,
      payload: value,
    });
  };
}

export function setGridLoading(value) {
  return async function (dispatch) {
    dispatch({
      type: CONFIGURATION.IS_GRIDLOADING,
      payload: value,
    });
  };
}

export function externalAndDataIntegration(providerId, clientId, data) {
  return async function (dispatch) {
    try {
      dispatch(setLoading(true));
      const response = await axios.post(
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
          "Configuration/Integration/ExternalAndDataIntegration",
        data,
        {
          params: {
            clientId: clientId,
            providerId: providerId,
          },
        }
      );
      dispatch(setLoading(false));
      if (response.data?.operationSuccessful) {
        dispatch(getProviderListById(clientId));
      }
      return response.data;
    } catch (error) {
      dispatch(setLoading(false));
      throw error;
    }
  };
}

export function configurationDeclarationUpdateEnabled(
  integrationId,
  clientId,
  isEnabled
) {
  return async function (dispatch) {
    try {
      await axios.post(
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
          "Configuration/Integration/ConfigurationDeclarationUpdateEnabled?integrationId=" +
          integrationId +
          "&isEnabled=" +
          isEnabled
      );

      dispatch(getProviderListById(clientId));
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getProviderListById(clientId) {
  return async function (dispatch) {
    try {
      dispatch(setGridLoading(true));
      let URL =
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
        "Configuration/Integration/GetProviderListById?clientId=" +
        clientId; //+"&dataIntegrationSP="+dataIntegrationSP;
      const response = await axios.get(URL);
      dispatch(setGridLoading(false));
      dispatch({
        type: CONFIGURATION.GET_PROVIDER_BYCLIENTID,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function GetDataIntegrationLog(clientId, level, configurationId) {
  return async function (dispatch) {
    try {
      let URL =
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
        "Configuration/Integration/GetDataIntegrationLog?clientId=" +
        clientId +
        "&level=" +
        level +
        "&configurationId=" +
        configurationId; //+"&dataIntegrationSP="+dataIntegrationSP;
      const response = await axios.get(URL);
      dispatch({
        type: CONFIGURATION.GET_DataIntegration_LOG,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getCompanies(clientId) {
  return async function (dispatch) {
    try {
      let URL =
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
        "Configuration/UserManagement/GetCompanies?clientId=" +
        clientId;
      const response = await axios.get(URL);
      dispatch({
        type: USERMANAGEMENT.GET_COMPANIES,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getProcessesByClient(clientId = "") {
    return async function (dispatch) {
        try {
            let URL =
                (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
                "Configuration/Integration/GetProcessingItemsByClient?clientId=" +
                clientId;
            const response = await axios.get(URL);
            dispatch({
                type: PROCESSINGITEMS.GET_PROCESSING_ITEMS,
                payload: HelperFunctions.responseHandlerVNext(response.data),
            });
        } catch (error) {
            console.log("error", error.response);
            console.log(typeof error);
        }
    };
}

export function stopRunningProcess(clientId = "", processId = "") {
    return async function (dispatch) {
        try {
            let URL =
                process.env.GET_PROCESSING_ITEMS +
                "DataIntegration/GetRecentProcessItems?clientId=" +
                clientId;
            const response = await axios.get(URL);
            dispatch({
                type: USERMANAGEMENT.GET_USERS_BY_CLIENT,
                payload: HelperFunctions.responseHandlerVNext(response.data),
            });
        } catch (error) {
            console.log("error", error.response);
            console.log(typeof error);
        }
    };
}

export function getUsersByClient(clientId = "", showDisabled = "") {
  return async function (dispatch) {
    try {
      let URL =
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
        "Configuration/UserManagement/GetUsers?clientId=" +
        clientId +
        "&showDisabled=" +
        showDisabled;
      const response = await axios.get(URL);
      dispatch({
        type: USERMANAGEMENT.GET_USERS_BY_CLIENT,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getUserTrustedDevices(userId) {
  return async function (dispatch) {
    try {
      let URL =
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
        "Configuration/UserManagement/GetUserTrustedDevices?userId=" +
        userId;
      const response = await axios.get(URL);
      dispatch({
        type: USERMANAGEMENT.GET_USER_TRUSTED_DEVICES,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
    }
  };
}

export const getUser2FAStatus = (userId) => async (dispatch) => {
  try {
    let URL = (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
        "Configuration/UserManagement/GetUser2FAStatus?userId=" +
        userId;
    const response = await axios.get(URL);
    return response.data.content;
  } catch (error) {
    console.error('Error fetching 2FA status:', error);
    throw error;
  }
};

export function removeUserTrustedDevice(userId, deviceToken) {
  return async function (dispatch) {
    try {
      let URL =
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
        "Configuration/UserManagement/RemoveUserTrustedDevice?userId=" +
        userId + "&deviceToken=" + deviceToken;
      const response = await axios.delete(URL);
      if (response.data.operationSuccessful) {
        // Refresh the devices list
        dispatch(getUserTrustedDevices(userId));
      }
    } catch (error) {
      console.log("error", error.response);
    }
  };
}

export function getUserByUserId(userId) {
  return async function (dispatch) {
    try {
      let URL =
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
        "Configuration/UserManagement/GetUserById?userId=" + userId;
      const response = await axios.get(URL);
      dispatch({
        type: USERMANAGEMENT.GET_USER_BY_USER_ID,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });

      return HelperFunctions.responseHandlerVNext(response.data);

    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function ResetPassword(email) {
  return async function (dispatch) {
    try {
      const URL =
        import.meta.env.VITE_VNEXT_BASE_URL +
        import.meta.env.VITE_VNEXT_API +
        "Configuration/UserManagement/ResetPassword?email="+ email;

      const response = await axios.post(URL);
      return response;
    } catch (error) {
      console.log("error", error.response || error.message);
    }
  };
}

export function addUser(params, clientId) {
  return async function (dispatch) {
    try {
      let URL =
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
        "Configuration/UserManagement/AddUser";
      const response = await axios.post(
        URL,
        {
          UserName: params.userName,
          Email: params.email,
          PasswordHash: params.password,
          FirstName: params.firstName,
          LastName: params.lastName,
          Enabled: params.enabled ? "True" : "False",
          RoleIds: Object.keys(params.roles)
            .map(function (k) {
              return params.roles[k].value;
            })
            .join(","),
        },
        {
          params: {
            clientId: clientId,
          },
        }
      );

      dispatch({
        type: USERMANAGEMENT.ADD_USER,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
    }
  };
}

export function updateUser(clientId, params) {
  return async function (dispatch) {
    try {
      let URL =
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
        "Configuration/UserManagement/UpdateUser";
      const response = await axios.patch(
        URL,
        {
          UserId: params.userId,
          UserName: params.userName,
          Email: params.email,
          PasswordHash: params.password,
          FirstName: params.firstName,
          LastName: params.lastName,
          Enabled: params.enabled ? "True" : "False",
          //EmailConfirmed: params.emailConfirmed ? "True" : "False",
          //IsLockedOut: params.isLockedOut ? "True" : "False",
          RoleIds: Object.keys(params.roles)
            .map(function (k) {
              return params.roles[k].value;
            })
            .join(","),
        },
        {
          params: {
            clientId: clientId,
            badgeColor: params.badgeColor,
            newComment: params.newComment,
            directMention: params.directMention,
            threadReplies: params.threadReplies,
            threadResolved: params.threadResolved
          },
        }
      );

      dispatch({
        type: USERMANAGEMENT.UPDATE_USER,
        payload: response.data,
      });
    } catch (error) {
      console.log("error", error.response);
    }
  };
}

export function checkUserPassword(clientId, params, currentPassword) {
  return async function (dispatch) {
    try {
      let URL =
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
        "Configuration/UserManagement/CheckUserPassword";
      const response = await axios.post(
        URL,
        {
          UserId: params.userId,
          PasswordHash: params.password,
        },
        {
          params: {
            clientId: clientId,
            currentPassword: currentPassword
          },
        }
      );

      dispatch({
        type: USERMANAGEMENT.CHECK_USER_PASSWORD,
        payload: response.data,
      });

      return HelperFunctions.responseHandlerVNext(response.data); 
    } catch (error) {
      console.log("error", error.response);
    }
  };
}

export function getClientRoles(clientId) {
  return async function (dispatch) {
    try {
      let URL =
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
        "Configuration/UserManagement/GetClientRoles?clientId=" +
        clientId;
      const response = await axios.get(URL);
      dispatch({
        type: USERMANAGEMENT.CLIENT_ROLES,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getMenu(clientId) {
  return async function (dispatch) {
    try {
      let URL =
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
        "Configuration/Menu/Get?clientId=" +
        clientId;
      const response = await axios.get(URL);
      dispatch({
        type: CONFIGURATION.GET_MENU_BY_CLIENTID,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export const getAccountManagers = () => async (dispatch) => {
  try {
    let URL = `${(import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API)}Configuration/ClientConfiguration/GetAccountManagers`;
    const response = await axios.get(URL);
    if (response.data.operationSuccessful) {
      let accountManagersOptions = [];
      response.data.content.forEach(function (item, index) {
        let temp = {};
        temp["label"] = item.name;
        temp["value"] = item.id;

        accountManagersOptions.push(temp);
      });
      dispatch({
        type: CONFIGURATION.GET_ACCOUNT_MANAGERS,
        payload: accountManagersOptions,
      });
    }
  } catch (error) {
    console.log("error", error.response);
    console.log(typeof error);
  }
};
export const getClientSettings = (clientId) => async (dispatch) => {
  try {
    let URL = `${(import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API)}Configuration/ClientConfiguration/GetClientSettings?clientId=${clientId}`;
    const response = await axios.get(URL);
    if (response.data.operationSuccessful) {
      dispatch({
        type: CONFIGURATION.GET_CLIENT_SETTINGS,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    }
  } catch (error) {
    console.log("error", error.response);
    console.log(typeof error);
  }
};

export const updateClientSettings = async (clientId, CSMId, supportHours) => {
  try {
    supportHours = supportHours === "" ? 0 : Math.ceil(supportHours);
    let URL = `${(import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API)}Configuration/ClientConfiguration/UpdateClientSettings?clientId=${clientId}&CSMId=${CSMId}&supportHours=${supportHours}`;
    const response = await axios.get(URL);
    if (response.data.operationSuccessful) {
      toast.success("Successfully updated client settings.");
    } else {
      toast.error("Failed to update client settings.");
    }
    return { supportHours };
  } catch (error) {
    console.log("error", error.response);
    console.log(typeof error);
  }
};

export function sendEmailAlert(provider, clientId) {
  return async function (dispatch) {
    try {
      let URL = (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) + `Configuration/Integration/SendEmailAlert`;
      await axios.post(
        URL,
        JSON.stringify({provider: provider, clientId: clientId}),
        {
          params: {
            clientId: clientId,
          },
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
    } catch (error) {
      console.log("error", error);
    }
  };
}

export function sendWooCommerceDetails(clientId, appUrl, consumerKey, consumerSecret) {
  return async function (dispatch) {
    try {
      let URL = (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) + `provider/WooCommerceProvider?clientId=${clientId}&&url=${appUrl}&&consumerKey=${consumerKey}&&consumerSecret=${consumerSecret}`;
      await axios.get(URL);
    } catch (error) {
      console.log("error", error);
    }
  };
}

export const updateWelcomePopupStatus = (status) => async (dispatch) => {
  try {
    dispatch({
      type: CONFIGURATION.SHOW_WELCOME_POPUP,
      payload: status,
    });
  } catch (error) {
    console.log("error", error.response);
    console.log(typeof error);
  }
};

export function sendVerifyEmail(clientId, isFromWebClient = false) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + `Configuration/UserManagement/SendVerifyEmail`;
      if(clientId){
        const response = await axios.post(URL, "", {
          params: {
            clientId: clientId,
            isFromWebClient: isFromWebClient,
          },
        });
        return response.data;
      }
    } catch (error) {
      console.log("error", error);
    }
  };
}

export function getWooCommerceBillingLink(clientId) {
  return async function (dispatch) {
    try {
      let URL = (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) + `Configuration/UserManagement/GetWooCommerceBillingLink?clientId=${clientId}`;
      const response = await axios.get(URL);
      return response.data
    } catch (error) {
      console.log("error", error);
    }
  };
}

export function GetManageColumns(clientId, entityName) {
  return async function (dispatch) {
      try {

          let URL = Constants.VNEXT_BASE_URL + 'Configuration/UserManagement/GetManageColumns?clientId=' + clientId + '&entityName='+ entityName;

          const response = await axios.get(URL);

          dispatch({
              type: USERMANAGEMENT.GET_MANAGE_COLUMNS,
              payload: HelperFunctions.responseHandlerVNext(response.data)
          });
      } catch (error) {
          console.log("error", error.response);
          console.log(typeof error);
      }
  };
}

export function SaveManageColumns(clientId, data, entityName) {
  return async function (dispatch) {
      try {

          let URL = Constants.VNEXT_BASE_URL + 'Configuration/UserManagement/SaveManageColumns';
          const formData = new FormData();
          formData.append("data", data ? JSON.stringify(data) : "");
          await axios.post(URL, formData, {
              params: {
                  clientId: clientId,
                  entityName: entityName
              },
              suppressToast: true
          });
      } catch (error) {
          console.log("error", error.response);
          console.log(typeof error);
      }
  };
}


/////////////////////////////// SMS
export function editSMSSettingParams(clientId, data, type) {
  return async function (dispatch) {
    try {
      await axios.post(
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
          "Configuration/SMSConfiguration/EditSMSConfigurationParams",
        data,
        {
          params: {
            clientId: clientId,
          },
        }
      );
      dispatch(getSMSConfigFormItems(clientId));
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function updateUnsubscribteText(clientId, data) {
  return async function (dispatch) {
    try {
      await axios.post(
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
          "Configuration/SMSConfiguration/UpdateUnsubscribedText",
        data,
        {
          params: {
            clientId: clientId,
          },
        }
      );
      dispatch(getSMSConfigFormItems(clientId));
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function deletePhoneNumber(clientId, phoneNumberId, type) {
  return async function (dispatch) {
    try {
      await axios.post(
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
          "Configuration/SMSConfiguration/DeletePhoneNumber",
        null,
        {
          params: {
            clientId: clientId,
            phoneNumberId: phoneNumberId,
          },
        }
      );
      dispatch(getSMSConfigFormItems(clientId));
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function addPhoneNumber(clientId, data, type) {
  return async function (dispatch) {
    try {
      await axios.post(
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
          "Configuration/SMSConfiguration/AddPhoneNumber",
        data,
        {
          params: {
            clientId: clientId,
          },
        }
      );
      dispatch(getSMSConfigFormItems(clientId));
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function editPhoneNumbers(clientId, data, type) {
  return async function (dispatch) {
    try {
      await axios.post(
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
          "Configuration/SMSConfiguration/UpdatePhoneNumbers",
        data,
        {
          params: {
            clientId: clientId,
          },
        }
      );
      dispatch(getSMSConfigFormItems(clientId));
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function addSMSSettingParams(clientId, data, type) {
  return async function (dispatch) {
    try {
      await axios.post(
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
          "Configuration/SMSConfiguration/AddSMSConfigListItems",
        data,
        {
          params: {
            clientId: clientId,
            configuratuionType: type,
          },
        }
      );
      dispatch(getSMSConfigFormItems(clientId));
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function addUpdateSmartEncoding(clientId, smartEncodingStatus) {
  return async function (dispatch) {
    try {
      await axios.post(
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
          `Configuration/SMSConfiguration/AddUpdateSmartEncoding?clientId=${clientId}&smartEncodingStatus=${smartEncodingStatus}`
      );
      // dispatch(getSMSConfigFormItems(clientId));
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getSmartEncodingStatus(clientId) {
  return async function (dispatch) {
    try {
      let URL =
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
        "Configuration/SMSConfiguration/GetSmartEncodingStatus?clientId=" + clientId;
      const response = await axios.get(URL);
      dispatch({
        type: CONFIGURATION.GET_SMS_SMART_ENCODING_STATUS,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getSMSPhoneNumbers(clientId){
  return async function (dispatch) {
    try {
      let URL =
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
        "Configuration/SMSConfiguration/GetPhoneNumbers?clientId=" + clientId;
      const response = await axios.get(URL);
      dispatch({
        type: CONFIGURATION.GET_SMS_PHONENUMBERS_BY_CLIENTID,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function addSMSCSVFileItems(clientId, file, type, configListId) {
  return async function (dispatch) {
    try {
      await axios.post(
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
          "Configuration/SMSConfiguration/AddCSVFileItems",
        file,
        {
          params: {
            clientId: clientId,
            configuratuionType: type,
            configurationListId: configListId,
          },
        }
      );
      dispatch(getSMSConfigFormItems(clientId));
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function addSMSConfigurationList(clientId, data, configurationType) {
  return async function (dispatch) {
    try {
      await axios.post(
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
          "Configuration/SMSConfiguration/AddConfigurationList",
        data,
        {
          params: {
            clientId: clientId,
            configuratuionType: configurationType,
          },
          suppressToast: true,
        }
      );

      dispatch(getSMSConfigFormItems(clientId));
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function editSMSConfigurationList(clientId, data, configurationType) {
  return async function (dispatch) {
    try {
      await axios.post(
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
          "Configuration/SMSConfiguration/EditConfigurationList",
        data,
        {
          params: {
            clientId: clientId,
            configuratuionType: configurationType,
          },
        }
      );

      dispatch(getSMSConfigurationList(clientId, configurationType));
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getSMSSettingItems(clientId, configurationType) {
  return async function (dispatch) {
    try {
      let URL = (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
        "Configuration/SMSConfiguration/GetSMSConfigurationItems?clientId=" + clientId +
        "&configuratuionType=" + configurationType;
      const response = await axios.get(URL);
      const { CONFIGURATION_TYPES } = Constants;

      switch (configurationType) {
        case CONFIGURATION_TYPES.SMS_SeedList:
          dispatch({
            type: CONFIGURATION.SMS_GET_SEEDLIST_BY_CLIENTID,
            payload: HelperFunctions.responseHandlerVNext(response.data),
          });
          break;
        case CONFIGURATION_TYPES.SMS_TestList:
          dispatch({
            type: CONFIGURATION.SMS_GET_TESTLIST_BY_CLIENTID,
            payload: HelperFunctions.responseHandlerVNext(response.data),
          });
          break;
        case CONFIGURATION_TYPES.SMS_FromEmail:
          dispatch({
            type: CONFIGURATION.SMS_GET_FROMEMAIL_BY_CLIENTID,
            payload: HelperFunctions.responseHandlerVNext(response.data),
          });
          break;
        case CONFIGURATION_TYPES.SMS_HelpEmail:
          dispatch({
            type: CONFIGURATION.SMS_GET_HELPEMAIL_BY_CLIENTID,
            payload: HelperFunctions.responseHandlerVNext(response.data),
          });
          break;
        // case CONFIGURATION_TYPES.TrackingParameter:
        //   dispatch({
        //     type: CONFIGURATION.GET_TRACKINGPARAMETER_BY_CLIENTID,
        //     payload: HelperFunctions.responseHandlerVNext(response.data),
        //   });
        //   break;
        case CONFIGURATION_TYPES.SMS_FromName:
          dispatch({
            type: CONFIGURATION.SMS_GET_FROMNAME_BY_CLIENTID,
            payload: HelperFunctions.responseHandlerVNext(response.data),
          });
          break;
        // case CONFIGURATION_TYPES.AppendTrackingParameters:
        //   dispatch({
        //     type: CONFIGURATION.GET_APPENDTRACKINGPARAMS_BY_CLIENTID,
        //     payload: HelperFunctions.responseHandlerVNext(response.data),
        //   });
        //   break;
        default:
          // Logging unknown case to identify if any case is not handled and needs to be handled
          console.log("No match case found for " + configurationType);
          break;
      }
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getSMSConfigFormItems(clientId) {
  return async function (dispatch) {
    try {
      let URL =
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
        "Configuration/SMSConfiguration/GetSMSConfigFormItems?clientId=" +
        clientId;
      const response = await axios.get(URL);
      dispatch({
        type: CONFIGURATION.GET_SMSCONFIGFORM_BY_CLIENTID,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

// ========== Premium Integration Wizard Actions ==========

export function getProviderMetadata(providerId) {
  return async function (dispatch) {
    try {
      dispatch({ type: CONFIGURATION.GET_PROVIDER_METADATA_REQUEST });
      
      let URL =
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
        `Configuration/Integration/GetProviderMetadata?providerId=${providerId}`;
      
      const response = await axios.get(URL);
      const result = HelperFunctions.responseHandlerVNext(response.data);
      
      dispatch({
        type: CONFIGURATION.GET_PROVIDER_METADATA_SUCCESS,
        payload: result,
      });
      
      return result;
    } catch (error) {
      console.log("getProviderMetadata error", error.response);
      dispatch({
        type: CONFIGURATION.GET_PROVIDER_METADATA_ERROR,
        payload: error.response?.data?.messages?.[0]?.messageContent || "Failed to load provider metadata",
      });
      throw error;
    }
  };
}

export function testConnection(providerId, credentials, clientId) {
  return async function (dispatch) {
    try {
      dispatch({ type: CONFIGURATION.TEST_CONNECTION_REQUEST });
      
      const URL =
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
        `Configuration/Integration/TestConnection?clientId=${clientId}`;
      
      const response = await axios.post(URL, {
        providerId,
        credentials,
      });
      
      // Always extract content, even if operationSuccessful is false
      // The content contains important fields like suggestion, errorCode, retryable
      const result = response.data.content || HelperFunctions.responseHandlerVNext(response.data);
      
      dispatch({
        type: CONFIGURATION.TEST_CONNECTION_SUCCESS,
        payload: result,
      });
      
      return result;
    } catch (error) {
      console.log("testConnection error", error.response);
      
      // Try to extract content from error response
      const errorContent = error.response?.data?.content;
      if (errorContent) {
        const actionType = errorContent.success === false
          ? CONFIGURATION.TEST_CONNECTION_ERROR
          : CONFIGURATION.TEST_CONNECTION_SUCCESS;
        dispatch({
          type: actionType,
          payload: errorContent,
        });
        return errorContent;
      }
      
      const errorMessage = error.response?.data?.messages?.[0]?.messageContent || "Connection test failed";
      
      dispatch({
        type: CONFIGURATION.TEST_CONNECTION_ERROR,
        payload: errorMessage,
      });
      
      throw error;
    }
  };
}

export function clearProviderMetadata() {
  return {
    type: CONFIGURATION.CLEAR_PROVIDER_METADATA,
  };
}

export function clearTestConnectionResult() {
  return {
    type: CONFIGURATION.CLEAR_TEST_CONNECTION_RESULT,
  };
}
